import { createMuiTheme } from "@material-ui/core/styles";

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: "rgba(244, 173, 69, 0.7)",
    },
    secondary: {
      main: "#b343ad",
    },
  },
  typography: {
    h1: {
      fontFamily: '"Dekko", cursive',
    },
    h2: {
      fontFamily: '"Dekko", cursive',
    },
    h3: {
      fontFamily: '"Dekko", cursive',
    },
    h4: {
      fontFamily: '"Dekko", cursive',
    },
    h5: {
      fontFamily: '"Dekko", cursive',
      color: "rgba(31, 31, 30, 0.8)",
    },
    h6: {
      fontFamily: '"Dekko", cursive',
      color: "rgba(31, 31, 30, 0.9)",
    },

    input: {
      fontFamily: '"Roboto", sans-serif',
    },
    span: {
      fontFamily: '"Roboto", sans-serif',
    },
  },
});
